export interface HaloResponse {
  matches: any[];
  logs: string[];
}

class HaloService {
  private baseUrl = 'http://localhost:8000/api/halo';  // Point to FastAPI server

  async runScan(description: string, region: string, searchType: string = 'person'): Promise<HaloResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/run`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          description,
          region: region === 'All Regions' ? undefined : region,
          searchType,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error in Halo scan:', error);
      throw error;
    }
  }
}

export default HaloService; 